const MagnifyingGlassIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M500.3 443.7l-99.7-99.7c28.4-34.9 45.4-79.4 45.4-127.1C446 98.1 347.9 0 224 0S2 98.1 2 217.9 100.1 435.8 224 435.8c47.7 0 92.2-17 127.1-45.4l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l15.6-15.6c9.4-9.4 9.4-24.6 0-33.9zM224 371.8c-84.8 0-153.9-69.1-153.9-153.9S139.2 64 224 64s153.9 69.1 153.9 153.9-69.1 153.9-153.9 153.9z" />
  </svg>
);

export default MagnifyingGlassIcon;
